import { InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { Card, Col, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import React, { useContext, useEffect } from 'react';

import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import useProfily from 'hooks/useProfily';

import { ISeznamNotifikaci } from 'services/profily';

interface IPrehled {}

/* const cardStyles = {
    // position: 'relative' as 'relative',
    // top: '-8px',
    //minWidth: '780px',
    paddingBottom: '10px'
};
*/

const Prehled: React.FC<IPrehled> = () => {
    const { aktivniFirma, menuProfile } = useContext(Context);
    const { setLevel } = useProfily();

    useEffect(() => {
        setLevel('dashboardWrapperTopSelected', ['prehled']);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const notifikaceTypMapa = [
        {
            typ: 'ZELENE',
            class: 'dash-card-not-green',
            icon: <InfoCircleOutlined className="dash-card-not-green-icon" />
        },
        {
            typ: 'ZLUTE',
            class: 'dash-card-not-yellow',
            icon: <WarningOutlined className="dash-card-not-yellow-icon" />
        },
        {
            typ: 'CERVENE',
            class: 'dash-card-not-red',
            icon: <WarningOutlined className="dash-card-not-red-icon" />
        }
    ];

    const notifikaceMap = (notifikace: ISeznamNotifikaci, i: number) => {
        return notifikaceTypMapa.map((x, index) => {
            if (x.typ === notifikace.typ) {
                return (
                    <div className={x.class} key={index}>
                        <Typography.Title level={4} key={i}>
                            {x.icon}
                            {notifikace.text}
                        </Typography.Title>
                    </div>
                );
            }
        });
    };

    return (
        <>
            <Row /* gutter={[16, 16]}*/>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Card
                        className="dash-card"
                        title={<TranslateText>{aktivniFirma?.spolecnost ? aktivniFirma.spolecnost : ''}</TranslateText>}
                    >
                        <Title text={aktivniFirma?.typ === 'UCASTNIK' ? 'CDAC' : 'FORMULARE_IC'} level={4} />
                        <p>{aktivniFirma?.ic}</p>
                        {aktivniFirma?.adresa && (
                            <>
                                <Title text="FORMULARE_ADRESA" level={4} />
                                <p>{aktivniFirma?.adresa}</p>
                            </>
                        )}
                        {menuProfile?.datplatamlz && (
                            <>
                                <Title text="DATUM_PLATNOSTI_AML" level={5} />
                                <Paragraph
                                    text={dayjs(menuProfile?.datplatamlz).format('DD.MM.YYYY')}
                                    className={
                                        dayjs(menuProfile?.datplatamlz) < dayjs().add(30, 'day')
                                            ? 'extramessage-text'
                                            : ''
                                    }
                                />
                            </>
                        )}
                        {aktivniFirma?.seznotifikaci?.map(notifikaceMap)}
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default Prehled;
